import React from "react";

const ActionCableContext = React.createContext({ cable: null });

export default ActionCableContext;
